module.exports = __webpack_public_path__ + "static/media/teacherscount.849422f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/teacherscount.png
// module id = 1226
// module chunks = 0